import FsVideo from "../../components/platformPlayer/fsVideo";
import FsVideoWcEndcard from "../../components/platformPlayer/FsVideoWcEndcard";

FsVideoWcEndcard.initEndcards();

let fsVideo = new FsVideo();
fsVideo.initializeFSEmbedPlayer();



// WEBPACK FOOTER //
// ./assets/layouts/video/fs-video-embed.js